<template>
    <div class="search-form" :class=page.page>
        <p class="header" v-html="title"></p>

        <div class="fieldset">

            <div v-if="page.page !== 'taxo'" class="one-filter">
                <p>Je souhaite découvrir</p>
                <custom-select
                        class="pin"
                        valueField="slug"
                        v-model="selectedDestinationValue"
                        :options="filters.destination"
                        v-on:change="updateDates($event)"
                ></custom-select>
            </div>

            <div class="one-filter">
                <p v-html="monthLabel"></p>
                <custom-select
                        class="calendrier"
                        valueField="date"
                        v-model="selectedDateValue"
                        :options="selectedDateOptions"

                ></custom-select>
            </div>

            <div v-if="page.page !== 'all' && page.page !== 'home'" class="one-filter">
                <p>Prix par personne</p>
                <custom-select
                        class="user"
                        valueField="price"
                        v-model="selectedPriceValue"
                        :options="filters.tarifs"
                ></custom-select>
            </div>
            <div class="one-filter validate">
                <a href="" class="btn chevron full-width" @click="applyFilters">Rechercher</a>
            </div>

        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import ScrollMagicGE from '../../libs/ScrollMagicGE';

    export default {
        props: {
            page: {
                type: Object,
                required: true,
            },
            filters: {
                type: Object,
                required: true,
            }

        },
        data() {
            return {
                selectedDateValue: null,
                selectedDestinationValue: this.$route.query.destination ? this.$route.query.destination : this.filters.destination[0].slug,
                selectedPriceValue: this.$route.query.price ? this.$route.query.price : this.filters.tarifs[0].price,
                selectedDateOptions: null,
            };
        },
        watch: {
            selectedDestinationValue(newValue, oldValue){

            }
        },
        computed: {
            title() {
                return this.page.page === "home" ? 'Votre voyage commence ici' : 'Votre voyage';
            },
            monthLabel() {
                return this.page.page === "home" || this.page.page === "all" ? 'Au mois de' : 'Mois de départ';
            }
        },
        mounted() {
            $('article.cruise-card').length > 1 ? ScrollMagicGE.searchCruiseForm() : null;

        },
        created(){
            if (this.page.page === 'taxo'){
                this.selectedDestinationValue = this.page.value
            }

            this.updateDates(this.selectedDestinationValue)

            if(this.$route.query.date){
                this.selectedDateValue = this.$route.query.date
            }

        },
        methods: {
            applyFilters() {

                let url = this.$route.path === '/' ? '/' + window.GrandsEspaces.hub_destination_slug + '/' : null;
                let query = {};

                if (this.page.page === "all" || this.page.page === 'home') {
                    query.date = this.selectedDateValue;
                    query.destination = this.selectedDestinationValue;
                }

                if (this.page.page === "taxo") {
                    query.date = this.selectedDateValue;
                    query.price = this.selectedPriceValue;
                }

                this.$router.push({
                    path: url,
                    query: query
                });
            },
            updateDates(value){
                let options = this.filters['destination'].find(option => option['slug'] === value);
                this.selectedDateOptions = options.dates
                this.selectedDateValue = options.dates[0].date
            }
        }
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/taxonomy-destination/SearchCruiseForm.vue